export default __webpack_public_path__ + "static/char-57-anr-ea54d4ac21b118597dcd031e44ca9fc2.gif";